export const SALES_REPORT = `SALES_REPORT`;

/* LAYOUT */
export const GET_SALES_REPORT_DATETIME_DATA = `${SALES_REPORT}/GET_SALES_REPORT_DATETIME_DATA`;
export const SET_SALES_REPORT_DATETIME_DATA = `${SALES_REPORT}/SET_SALES_REPORT_DATETIME_DATA`;

export const CHECK_AGENT_IS_LEAF_NODE = `${SALES_REPORT}/CHECK_AGENT_IS_LEAF_NODE`;

export const GET_SALES_REPORT_INDIVIDUAL_DATA = `${SALES_REPORT}/GET_SALES_REPORT_INDIVIDUAL_DATA`;
export const GET_SALES_REPORT_GROUP_DATA = `${SALES_REPORT}/GET_SALES_REPORT_GROUP_DATA`;
export const SET_SALES_REPORT_TABLE_DATA = `${SALES_REPORT}/SET_SALES_REPORT_TABLE_DATA`;

export const GET_SALES_REPORT_SUMMARY_DATA = `${SALES_REPORT}/GET_SALES_REPORT_SUMMARY_DATA`;
export const SET_SALES_REPORT_SUMMARY_DATA = `${SALES_REPORT}/SET_SALES_REPORT_SUMMARY_DATA`;

export const GET_SALES_REPORT_PIE_CHART_DATA = `${SALES_REPORT}/GET_SALES_REPORT_PIE_CHART_DATA`;
export const SET_SALES_REPORT_PIE_CHART_DATA = `${SALES_REPORT}/SET_SALES_REPORT_PIE_CHART_DATA`;

export const SET_SALES_REPORT_BREADCRUMB_DATA = `${SALES_REPORT}/SET_SALES_REPORT_BREADCRUMB_DATA`;
export const SET_SALES_REPORT_SELECTED_BREADCRUMB_ID = `${SALES_REPORT}/SET_SALES_REPORT_SELECTED_BREADCRUMB_ID`;

export const SET_SALES_REPORT_SELECTED_TAB_DATA = `${SALES_REPORT}/SET_SALES_REPORT_SELECTED_TAB_DATA`;

export const SET_SALES_REPORT_FILTER = `${SALES_REPORT}/SET_SALES_REPORT_FILTER`;

export const GET_SALES_REPORT_POLICY_DATA = `${SALES_REPORT}/GET_SALES_REPORT_POLICY_DATA`;
export const SET_SALES_REPORT_POLICY_DATA = `${SALES_REPORT}/SET_SALES_REPORT_POLICY_DATA`;

export const RESET_STATE = 'RESET_STATE';

export const FETCH_TEAM_POLICY_LIST_START = `${SALES_REPORT}/FETCH_TEAM_POLICY_LIST_START`;
export const FETCH_TEAM_POLICY_LIST_SUCCESS = `${SALES_REPORT}/FETCH_TEAM_POLICY_LIST_SUCCESS`;
